import React, { useEffect } from 'react'
import ThemeContext from './ThemeContext'
import useTheme from './useTheme'

const ThemeProvider = (props) => {
	const { theme: themeProp, children } = props

	const { theme, setTheme } = useTheme(themeProp)

	useEffect(() => {
		setTheme(themeProp)
	}, [themeProp])

	return (
		<ThemeContext.Provider
			value={{
				theme,
				setTheme
			}}
		>
			{children}
		</ThemeContext.Provider>
	)
}

export default ThemeProvider
